import styled from 'styled-components';
import { Table, TableCell, TableRow } from '@material-ui/core';

export const LoaderOverlay = styled.div`
  background-color: rgb(250 250 250 / 35%);
  position: absolute;
  top: 1px;
  width: 100%;
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
`;

export const StyledTableHeaderCell = styled(TableCell)<{ clickable?: boolean }>`
  font-weight: bold;
  border-bottom: 0;

  cursor: ${(props) => (props.clickable ? 'pointer' : 'default')};

  :hover {
    background-color: ${(props) => (props.clickable ? '#fafafa' : '')};
  }
`;

export const StyledTableRow = styled(TableRow)<{ clickable?: boolean }>`
  > th,
  td {
    border-bottom: 0;
  }
  :nth-child(odd) {
    background-color: #fafafa;
  }
  cursor: ${(props) => (props.clickable ? 'pointer' : 'default')};
`;

export const TableWrapper = styled(Table)`
  position: 'relative';
`;

export const NoItemsStyled = styled.div`
  font-size: 16px;
  padding-left: 21px;
  padding-top: 21px;
`;
